import { ORDER_PAGE_TURNED_OVER_CODE } from '@messenger/consts'

/**
 * Whether the order-page PATCH refused a save because its page JSON would
 * undo a Lotus turnover: the stored page carries a turnover run id this tab's
 * JSON lacks or differs from, because the tab loaded the page before the
 * page set was turned over.
 */
export const isOrderPageTurnedOverError = (error: unknown): boolean =>
  (error as { response?: { data?: { code?: string } } })?.response?.data
    ?.code === ORDER_PAGE_TURNED_OVER_CODE
